import React, { useState, useEffect } from "react";
import styles from "./Footer.module.scss";
import telegram from "../Footer/images/telegram.svg";
import vk from "../Footer/images/vk.svg";
import odnockasnic from "../Footer/images/Odnaclas.svg";
import { NavLink, useNavigate } from "react-router-dom";

type FooterProps = {};

const Footer: React.FC<FooterProps> = () => {
  const navigate = useNavigate();
  const [isSmallScreen, setIsSmallScreen] = useState<boolean>(false); // Для проверки ширины экрана

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 769);
    };

    handleResize(); // Проверяем ширину экрана при загрузке компонента
    window.addEventListener("resize", handleResize);

    return () => {
      window.removeEventListener("resize", handleResize); // Удаляем обработчик при размонтировании
    };
  }, []);

  return (
    <>
      {/* Логотип и социальные иконки */}
      <div className={styles["Logo-icon"]}>
        <NavLink to="/" onClick={() => navigate(`homePage`)}>
          <p className={styles["Footer-firstColumn"]}>А — КАССА</p>
        </NavLink>{" "}
        <div className={styles["Footer-social-header"]}>
          <div className={styles["Footer-icons-header"]}>
            <a href="https://t.me" target="_blank" rel="noopener noreferrer">
              <img src={telegram} alt="Telegram" />
            </a>
            <a href="https://vk.com/" target="_blank" rel="noopener noreferrer">
              <img src={vk} alt="Вконтакте" />
            </a>
            <a href="https://ok.ru/" target="_blank" rel="noopener noreferrer">
              <img src={odnockasnic} alt="Одноклассники" />
            </a>
          </div>
        </div>
      </div>

      {/* Основной футер */}
      <footer className={styles.Footer}>
        <div className={styles["FooterWrapper"]}>
          <div className={styles["Footer-leftBlock"]}>
            {/* Первая колонка: Логотип */}
            {!isSmallScreen && (
              <NavLink to="/" className={styles["Footer-firstColumn"]} end>
                А — КАССА
              </NavLink>
            )}

            {/* <div className={styles["Footer-rightBlock"]}> */}
            <div className={styles["Footer-social"]}>
              <div className={styles["Footer-icons"]}>
                <a href="https://t.me" target="_blank" rel="noopener noreferrer">
                  <img src={telegram} alt="Telegram" />
                </a>
                <a
                  href="https://vk.com/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={vk} alt="Вконтакте" />
                </a>
                <a
                  href="https://ok.ru/"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={odnockasnic} alt="Одноклассники" />
                </a>
              </div>
              {/* </div> */}
            </div>
          </div>

          {/* Вторая колонка: Ссылки */}
          <div className={styles["Footer-secondColumn"]}>
            <div className={styles["Footer-links"]}>
              <ul>
                {[
                  { to: "/information/refunds", text: "Возврат билетов" },
                  { to: "/information/offer", text: "Публичная оферта" },
                ].map((link, index) => (
                  <li key={index}>
                    <NavLink to={link.to} onClick={() => navigate(link.to)}>
                      {link.text}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
            <div className={styles["Footer-links"]}>
              <ul>
                {[
                  { to: "/", text: "Афиша событий" },
                  { to: "/createEventPage", text: "Создать событие" },
                ].map((link, index) => (
                  <li key={index}>
                    <NavLink to={link.to} onClick={() => navigate(link.to)}>
                      {link.text}
                    </NavLink>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className={styles.details}>
            <div>
              <p>Антипов Илья Геннадьевич</p>
              <p>ИНН 780245947470</p>
              <p>ОГРН 321784700063007</p>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
};

export default Footer;
